import { createActions } from 'utils/actions';

export const setCaseListSettings = createActions('ui', 'SET_CASE_LIST_SETTINGS');
export const setUnknownCaseSettings = createActions('ui', 'SET_UNKNOWN_CASE_SETTINGS');
export const setMessagesSearch = createActions('ui', 'SET_MESSAGES_SEARCH');
export const setMeetingsFilters = createActions('ui', 'SET_MEETINGS_FILTERS');
export const setMessagesFilters = createActions('ui', 'SET_MESSAGES_FILTERS');
export const setPreppedAnswerSettings = createActions('ui', 'SET_PREPPED_ANSWER_SETTINGS');
